export default {
  data(){
    return{
      observer : null
    }
  },
  mounted(){
    this.observer = new IntersectionObserver(this.onIntersect, {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: .5,
    })

    this.observer.observe(this.$el)
  },
  destroyed(){
    this.observer.disconnect()
    this.observer = null
  },
  methods: {
    // onIntersect(event) {
    //   const cominghome = this.$refs.cominghome;
    //   const isIntersecting = event.find((entry) => {
    //     return entry.isIntersecting
    //   })
    //   if (isIntersecting) {
    //     this.$emit('intersect', event)
    //     // console.log("coming home intersecting")
    //     cominghome.querySelector('h1').classList.add("test");
    //     cominghome.querySelector('h3').classList.add("test2");
    //   }
    // },
  }

}


// WEBPACK FOOTER //
// ./src/mixins/isIntersectingMixin.js